import { blue, blueDark, red, textMuted, white } from '@/theme/colors'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

/** Shared styles for the read-only admin detail pages (User, Trip, Event, Idea, Expense). */

export const BackLink = styled(Link)`
	display: inline-block;
	margin-bottom: 1rem;
	color: ${blue};
	text-decoration: none;
	font-weight: 600;
	font-size: 0.9rem;

	&:hover {
		text-decoration: underline;
	}
`

export const DetailHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	flex-wrap: wrap;
	margin-bottom: 1.5rem;
`

export const DetailTitle = styled.h1`
	margin: 0;
	font-size: 1.6rem;
	font-weight: 700;
	color: ${blue};
`

export const DeletedBadge = styled.span`
	display: inline-block;
	padding: 0.15rem 0.55rem;
	border-radius: 6px;
	background-color: ${red};
	color: ${white};
	font-size: 0.75rem;
	font-weight: 700;
`

export const Card = styled.div`
	background-color: ${white};
	border-radius: 12px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	padding: 1.5rem;
	margin-bottom: 1.25rem;
`

export const CardTitle = styled.h2`
	margin: 0 0 1rem;
	font-size: 1.05rem;
	font-weight: 600;
	color: ${textMuted};
`

export const FieldGrid = styled.dl`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 1rem 1.5rem;
	margin: 0;
`

export const Field = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	min-width: 0;
`

export const FieldLabel = styled.dt`
	font-size: 0.78rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.03em;
	color: ${textMuted};
`

export const FieldValue = styled.dd`
	margin: 0;
	font-size: 0.98rem;
	color: ${blue};
	word-break: break-word;
`

export const InlineLink = styled(Link)`
	color: ${blue};
	font-weight: 600;
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
`

export const RelatedList = styled.div`
	display: flex;
	flex-direction: column;
`

export const RelatedRow = styled(Link)<{ $deleted?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 0.7rem 0.25rem;
	border-bottom: 1px solid ${textMuted}14;
	text-decoration: none;
	color: ${blue};
	background-color: ${({ $deleted }) => ($deleted ? `${red}0d` : 'transparent')};

	&:last-child {
		border-bottom: none;
	}
	&:hover {
		background-color: ${blue}0d;
	}
`

export const RelatedRowStatic = styled.div<{ $deleted?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 0.7rem 0.25rem;
	border-bottom: 1px solid ${textMuted}14;
	color: ${blue};
	background-color: ${({ $deleted }) => ($deleted ? `${red}0d` : 'transparent')};

	&:last-child {
		border-bottom: none;
	}
`

export const RelatedMeta = styled.span`
	color: ${textMuted};
	font-size: 0.85rem;
	white-space: nowrap;
`

export const Tag = styled.span`
	display: inline-block;
	padding: 0.15rem 0.55rem;
	margin: 0 0.35rem 0.35rem 0;
	border-radius: 999px;
	background-color: ${blue}14;
	color: ${blueDark};
	font-size: 0.8rem;
`

export const Chips = styled.div`
	display: flex;
	flex-wrap: wrap;
`

export const EmptyState = styled.div`
	color: ${textMuted};
	font-size: 0.9rem;
	padding: 0.5rem 0;
`

export const ErrorState = styled.div`
	color: ${textMuted};
	font-size: 1rem;
`
